import GeneralTranslations from "../../../Common/ModuleTranslations/es";

export default {
  locale: "es",
  name: "Políticas de cancelación",
  translation: { displayName: "Traducciones" },
  fields: {
    /** Here are te entities used in the lists, Order is important */
    /** fieldName: this is used like the id container of the properties */
    /** displayName: this is the title rendered */
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "ordering",
        displayName: "Orden",
      },
      {
        fieldName: "active",
        displayName: "Activo",
        restrictionMessage:
          "Política vinculada a una condición. No es posible realizar esta acción",
      },
      {
        fieldName: "name",
        displayName: "Nombre",
      },
      {
        fieldName: "motorsList",
        displayName: "Motores",
      },
      {
        fieldName: "uso",
        displayName: "Uso",
      },
      {
        fieldName: "dates",
        displayName: "Fechas",
      },
      {
        fieldName: "enableAutomaticCharge",
        displayName: "Cargos automáticos",
      },
      {
        fieldName: "penaltyDeposit",
        displayName: "Cobro online gastos",
      },
    ],
    /** Here is the entity used in the forms, Order is important */
    /** all the properties can be found in app/components/CRUD/Common, at the corresponding js file */
    /** fieldName: is like the id in html, it must be unique among the attributes */
    /** widget: is used to render the kind of interaction the user will have, a complete list can be found in component/CRUD/Common */
    /** displayName: The text that introduces the widget */
    /** defaultValue: The default value of the widget */
    /** optionDisplay: An object that containes objects with the option at the select */
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "propertyTicker",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Activo",
      },
      {
        fieldName: "validFrom",
        placeholder: "Introduce una fecha",
        displayName: "Fecha inicio",
        tooltip:
          "Esta fecha hace referencia al momento en el que se producirá la estancia (travel window). La política se activará si las fechas de check-in y check-out buscadas están dentro del rango",
      },
      {
        fieldName: "validTo",
        placeholder: "Introduce una fecha",
        displayName: "Fecha fin",
      },
      {
        fieldName: "ordering",
        widget: "hidden",
      },
      {
        /** In nested entities the fieldName must be used in the form so it knows which entities must be declared respectively. No need to put in the router the components*/
        fieldName: "configurations",
        displayName: "Penalizaciones",
        introductionText: [
          "Crea diferentes penalizaciones dependiendo de la antelación de la cancelación",
          "Importante! Comprobar que las políticas no entren en conflicto, revisar en el motor que se apliquen correctamente",
        ],
        widget: "nestedEntity",
        nested: true,
        entityName: "CancellationPolicyConfiguration",
        nestedTitle: "Edición penalizaciones",
        defaultValue: [],
      },
      {
        fieldName: "agrWarningMessage",
        displayName: "",
      },
      {
        fieldName: "enableAutomaticCharge",
        widget: "checkbox",
        description: "Activar cargos automáticos según las políticas de cancelación",
        helpText:
          "Al activar esta opción, la reserva se cobrará según los plazos de penalización de cancelación. Esta opción solo se aplica a los métodos de pago compatibles (métodos de pago que permiten cargos diferidos en el back office del motor).",
        defaultValue: false,
      },
      {
        fieldName: "penaltyDeposit",
        widget: "checkbox",
        description:
          "Ejecutar el primer pago online - cuando se generan gastos en el momento de la reserva",
        helpText:
          "Al activar esta opción y si se generan gastos en el momento de la reserva, se cobrará el depósito de la política.",
        defaultValue: false,
      },
      {
        fieldName: "description",
        placeholder: "Descripción",
        displayName: "Descripción",
      },
      {
        fieldName: "selectedMotorsSection",
        displayName: "Motores asociados",
      },
    ],
  },
  validation: {
    validFrom: {
      constraints: {
        compare: {
          message: "^La fecha de fin no puede ser anterior a la fecha de inicio.",
        },
      },
    },
    validTo: {
      constraints: {
        compare: {
          message: "^La fecha de fin no puede ser anterior a la fecha de inicio.",
        },
      },
    },
  },
};
